<template>
    <div class="relative w-40 h-40 md:w-60 md:h-60 rounded-[1rem] overflow-hidden shadow-lg shrink-0 bg-gray-200 dark:bg-gray-800 animate-pulse">
        <!-- Background Mock Shimmer -->
        <div class="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 dark:from-gray-800 dark:via-gray-750 dark:to-gray-800 bg-[length:200%_100%] animate-shimmer"></div>

        <!-- Glassmorphism Bottom Overlay -->
        <div class="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/20 to-transparent pt-12 flex flex-col justify-end">
            <div class="backdrop-blur-md bg-white/10 dark:bg-black/20 border border-white/10 p-3 rounded-b-[1rem] shadow-sm flex flex-col gap-2">
                <!-- Title skeleton -->
                <div class="h-4 bg-gray-300/60 dark:bg-gray-700/60 rounded w-3/4 animate-pulse"></div>
                <!-- Description skeleton -->
                <div class="h-3 bg-gray-300/40 dark:bg-gray-700/40 rounded w-1/2 animate-pulse"></div>
            </div>
        </div>

        <!-- Icon placeholders (top-left & top-right) -->
        <div class="absolute top-3 right-3 w-8 h-8 rounded-full bg-gray-300/30 dark:bg-gray-700/30 backdrop-blur-sm"></div>
        <div class="absolute top-3 left-3 w-8 h-8 rounded-full bg-gray-300/30 dark:bg-gray-700/30 backdrop-blur-sm"></div>
    </div>
</template>

<style scoped>
@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }
    100% {
        background-position: 200% 0;
    }
}
.animate-shimmer {
    animation: shimmer 1.5s infinite linear;
}
</style>
